// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1wBVv","col":"styles_col__34bKN","fulfillmentStatus":"styles_fulfillmentStatus__36tj7","emailCol":"styles_emailCol__sFrg7"};